import React from 'react';

import { Content, ContentRow, Label, PlayerGroup, Value } from '@pkg/components/Common/CardTile/CardBottom';
export const CardFantasyPlayers = ({ playerCount }: { playerCount?: number }) => {
    return (
        <PlayerGroup>
            <Label>Players</Label>
            <ContentRow>
                <Content>
                    <Value>{playerCount}</Value>
                </Content>
            </ContentRow>
        </PlayerGroup>
    );
};
